import { Observable } from 'rxjs';
import { ApiDataService } from './api.data.service';
import { AbstractModel } from '../../models';
import { HttpParams } from '@angular/common/http';

export abstract class ApiListDataService<
    L extends AbstractModel,
    T extends AbstractModel,
> extends ApiDataService<T> {
    getItems = (): Observable<L[]> => {
        return this.get<L[]>('');
    };

    getItemsParams = (params: string): Observable<L[]> => {
        return this.get<L[]>(params);
    };

    getItemsParamsPaginations = (params: string): Observable<{ data: L[]; totalCount: number }> => {
        return this.get<{ data: L[]; totalCount: number }>(params);
    };

    getItemsWithCustomParams = (action: string, customParams: any): Observable<L[]> => {
        let params = new HttpParams();
        for (const key in customParams) {
            if (customParams[key] != null) {
                params = params.set(key, customParams[key]);
            }
        }

        return this.get<L[]>(null, params);
    };

    getItemsByHttpParams = (action: string, params: any): Observable<L[]> => {
        return this.get<L[]>(action, params);
    };

    createItemParams = (params: string, data: any): Observable<T> => {
        return this.post<T>(params, JSON.stringify(data));
    };

    updateItemParams = (params: string, data: any): Observable<T> => {
        return this.put<T>(params, JSON.stringify(data));
    };

    saveFile = (): Observable<L[]> => {
        return this.save<L[]>('');
    };
}
